import React, { useEffect, useState, ChangeEvent, useRef } from "react";
import { CheckIcon, Squares2X2Icon } from "@heroicons/react/24/outline";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { useNavigate } from "react-router-dom";
import ButtonPrimary from "shared/Button/ButtonPrimary";
import DetailPagetLayout from "../Layout";
import { Checkbox } from "@headlessui/react";
import toast from "react-hot-toast";
import { formatDateTime, useData } from "data/data-provider";
import { getInvoice } from "api/Invoice/invoice";
import { Booking } from "api/booking/booking";
import { globalJson } from "global/global_json";
import Input from "shared/Input/Input";
import { getBonzahProducts } from "api/bonzah/bonzah";
import { AddCustomer } from "api/customer/customer";
import moment from "moment";
import Badge from "shared/Badge/Badge";
import LocationBranchInput from "components/HeroSearchForm/LocationBranchInput";
import DropOffBranchLocationInput from "components/HeroSearchForm/DropOffBranchLocationInput";
import RentalCarDatesRangeInput from "components/HeroSearchForm/(car-search-form)/RentalCarDatesRangeInput";
import RentalCarTimesRangeInput from "components/HeroSearchForm/(car-search-form)/RentalCarTimesRangeInput";
import { getLocationData } from "api/locations/locations";
import { LocationListingModal } from "models/LocationModal";

export default function ListingCarDetailPage() {
  const navigate = useNavigate();
  const initialBonzahFetched = useRef(false);
  const {
    selectedCar,
    user,
    startDate,
    startHours,
    startMinutes,
    startPeriod,
    endDate,
    endHours,
    endMinutes,
    pickupLocation,
    setInvoice,
    selectedExtras,
    setSelectedExtras,
    bonzahProducts,
    setBookingdetails,
    setBonzahProducts,
    setSelectedBonzahProducts,
    selectedBonzahProducts,
    setSelectedBonzahAddOns,
    selectedBonzahAddOns,
    invoice,
    dropOffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
    sameDropoffLocation,
    dropoffLocationType,
    endPeriod,
    firstName,
    setFirstName,
    lastName,
    setLastName,
    email,
    setEmail,
    phone,
    setPhone,
    setDropoffLocation,
    setSameDropoffLocation,
    setDropoffLocationType,
    startTime,
    endTime,
  } = useData();

  let [bonzahProductsLoading, setBonzahProductsLoading] = useState(false);
  const isDdropOffdifferent = dropoffLocationType === false;
  const [selectedBonzahType, setSelectedBonzahType] = useState<any>([]);
  const [isDropOffVisible, setIsDropOffVisible] = useState(false);
  const [loadingLater, setLoadingLater] = useState(false);
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [loading, setLoading] = useState<boolean>(false);
  const [isMoreThan30Days, setIsMoreThan30Days] = useState(false);
  const [isReadMore, setIsReadMore] = useState(true);
  const [selectedBonzah, setSelectedBonzah] = useState();
  const [showImgGallery, setShowImgGallery] = useState(false);
  const [ourLocation, setOurLocation] = useState<LocationListingModal[]>([]);

  const toggleReadMore = () => {
    setIsReadMore(!isReadMore);
  };

  const validateForm = () => {
    const newErrors: { [key: string]: string } = {};
    if (!firstName) newErrors.firstName = "First Name is required";
    if (!lastName) newErrors.lastName = "Last Name is required";
    if (!email || !/^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(email)) {
      newErrors.email = "Please enter a valid email address";
    }
    if (!phone || phone.length < 10) {
      newErrors.phone = "Please enter a valid phone number";
    }
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0; // Return false if there are any errors
  };

  // Clear specific field error
  const clearError = (field: string) => {
    setErrors((prevErrors) => {
      const updatedErrors = { ...prevErrors };
      delete updatedErrors[field];
      return updatedErrors;
    });
  };

  const fetchBonzahProducts = async (selectedType?: string) => {
    setBonzahProductsLoading(true);

    const payload = {
      company_id: globalJson.company_id,
      selected_type: selectedType,
      fleet: selectedCar?.id,
    };

    const { data, error } = await getBonzahProducts(payload);

    if (data) {
      setBonzahProducts(data);
      const validAddOns = new Set(
        Array.from(selectedBonzahAddOns).filter((addon: any) =>
          data?.addons?.some((item: any) => item.value[0] === addon)
        )
      );
      setSelectedBonzahAddOns(validAddOns);
      if (data?.insurance_options?.length > 0) {
        if (selectedBonzahType?.length === 0) {
          setSelectedBonzahProducts(new Set([data.insurance_options[0].value]));
          setSelectedBonzahType(data.insurance_options[0].value);
        }
      }
      setBonzahProductsLoading(false);
    } else if (error) {
      setBonzahProductsLoading(false);
    }
  };

  useEffect(() => {
    if (startDate && endDate) {
      const start = moment(startDate);
      const end = moment(endDate);
      const daysDifference = end.diff(start, "days");

      if (daysDifference > 30) {
        setIsMoreThan30Days(true);
        toast("Bonzah Insurance is not available for more than 30 days", {
          style: {
            background: "#fff3cd",
            color: "#856404",
          },
        });
      } else {
        setIsMoreThan30Days(false);
      }
    }
  }, [startDate, endDate]);

  useEffect(() => {
    if (!initialBonzahFetched.current) {
      const fetchInitialBonzah = async () => {
        const { data } = await getBonzahProducts({
          company_id: globalJson.company_id,
          fleet: selectedCar?.id,
        });

        if (data) {
          setBonzahProducts(data);
          if (data.insurance_options?.length > 0) {
            setSelectedBonzahProducts(
              new Set([data.insurance_options[0].value])
            );
            setSelectedBonzahType(data.insurance_options[0].value);
            fetchBonzahProducts(data.insurance_options[0].title.toLowerCase());
            setSelectedBonzah(data.insurance_options[0].title.toLowerCase());
          }
        }
      };
      fetchInitialBonzah();
      initialBonzahFetched.current = true;
    } else {
      if (selectedBonzahType?.length > 0) {
        fetchBonzahProducts(selectedBonzah);
      } else {
        fetchBonzahProducts();
      }
    }
  }, [startDate, endDate]);

  const toggleAddonSelection = (addonType: string) => {
    setSelectedBonzahAddOns((prevSelected) => {
      const updatedSet = new Set(prevSelected);
      if (updatedSet.has(addonType)) {
        updatedSet.delete(addonType);
      } else {
        updatedSet.add(addonType);
      }
      return updatedSet;
    });
  };

  useEffect(() => {
    const fetchInvoice = async () => {
      if (isDdropOffdifferent && dropOffLocation === null) {
        return;
      } else {
        const selectedAddons = Array.from(selectedBonzahAddOns);
        const addonsValues = selectedAddons
          .map((item) => {
            const addon = bonzahProducts.addons.find(
              (addon: any) => addon.value[0] === item
            );
            return addon ? addon.value : [];
          })
          .flat();

        const payload = {
          customer: user?.id,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off_address: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        const data = await getInvoice(payload);
        setInvoice(data);
      }
    };
    fetchInvoice();
  }, [
    selectedExtras,
    selectedBonzahProducts,
    selectedBonzahAddOns,
    pickupLocation,
    startMinutes,
    startPeriod,
    startHours,
    endMinutes,
    endPeriod,
    endHours,
    endMinutes,
    endPeriod,
    startDate,
    endDate,
    dropOffLocation,
    sameDropoffLocation,
    searchedPickupLoction,
    searchedDropoffLocation,
  ]);

  useEffect(() => {
    if (selectedCar) {
      callOurLocationAPI();
    }
  }, [selectedCar]);

  const callOurLocationAPI = async () => {
    if (selectedCar) {
      try {
        const data = await getLocationData(selectedCar?.id);
        if (Array.isArray(data)) {
          setOurLocation(data as LocationListingModal[]);
        } else {
          throw new Error("Unable to fetch location data");
        }
      } catch (error: any) {
        toast.error(error.message || "Failed to fetch locations");
        console.error("Location API error:", error);
      } finally {
        setLoading(false);
      }
    }
  };

  useEffect(() => {
    setSelectedExtras(new Set());
    setSelectedBonzahProducts(new Set());
    setSelectedBonzahAddOns(new Set());
    localStorage.removeItem("access_token");
    localStorage.removeItem("refresh_token");
    localStorage.removeItem("user");
  }, []);

  const handleBooking = async () => {
    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }

    setLoading(true);

    const selectedAddons = Array.from(selectedBonzahAddOns);
    const addonsValues = selectedAddons
      .map((item) => {
        const addon = bonzahProducts.addons.find(
          (addon: any) => addon.value[0] === item
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.data.detail) {
        toast.error(response.data.detail);
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }
      if (response.data) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        const customerId = response.data.id;

        const payload = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
        };

        const bookingResponse = await Booking(payload);
        setBookingdetails(bookingResponse);
        if (bookingResponse.error) {
          toast.error(bookingResponse.error);
          return;
        }

        navigate("/checkout");
      }
    } catch (err: any) {
      setLoading(false);
    } finally {
      setLoading(false);
    }
  };

  const handleBookingLater = async () => {
    if (isDdropOffdifferent && dropOffLocation === null) {
      toast.error("Please select drop-off location");
      return;
    }
    if (startDate === null && endDate === null) {
      toast.error("Please enter start and end date");
      return;
    }

    if (!validateForm()) {
      toast.error("Please fill in the details");
      return;
    }

    setLoadingLater(true);

    const selectedAddons = Array.from(selectedBonzahProducts)?.filter((item) =>
      bonzahProducts?.addons.some((addon: any) => addon.value[0] === item)
    );

    const addonsValues: string[] = selectedAddons
      .map((item) => {
        const addon = bonzahProducts?.addons?.find(
          (addon: any) => addon.value[0] === item
        );
        return addon ? addon.value : [];
      })
      .flat();

    const customerPayload = {
      first_name: firstName,
      last_name: lastName,
      email,
      phone_no: phone,
      company: globalJson.company_id,
    };

    try {
      const response = await AddCustomer(customerPayload);
      if (response.error) {
        toast.error(response.error);
        return;
      }
      if (!startDate || !endDate) {
        toast.error("No start date or end date");
        return;
      }

      if (response.data) {
        localStorage.setItem("access_token", response.data.access_token);
        localStorage.setItem("refresh_token", response.data.refresh_token);
        localStorage.setItem("user", JSON.stringify(response.data));

        const customerId = response.data.id;

        const payload = {
          customer: customerId,
          fleet: selectedCar?.id,
          pick_up_time: formatDateTime(startDate, startTime),
          drop_off_time: formatDateTime(endDate, endTime),
          pick_up_location: pickupLocation?.id,
          drop_off_location:
            sameDropoffLocation === false
              ? dropOffLocation?.id
              : pickupLocation?.id,
          custom_pick_up_address: searchedPickupLoction,
          custom_drop_off_address:
            sameDropoffLocation === false
              ? searchedDropoffLocation
              : searchedPickupLoction,
          same_drop_off: sameDropoffLocation,
          extras: Array.from(selectedExtras),
          bonzah_insurance_options: [...selectedBonzahType, ...addonsValues],
          pay_later: true,
        };

        const bookingdetail = await Booking(payload);
        if (bookingdetail.error) {
          toast.error(bookingdetail.error);
          setLoadingLater(false);
          return;
        }
        setBookingdetails(bookingdetail);
        toast.success("Your Booking is reserved");
        navigate(`/booking-details?id=${bookingdetail?.unique_identifier}`);
      }
    } catch (err: any) {
      toast.error(err.message || "Failed to complete booking");
      setLoadingLater(false);
    } finally {
      setLoadingLater(false);
    }
  };

  const hasCanopyOption = () => {
    return (
      Array.isArray(bonzahProducts?.insurance_options) &&
      bonzahProducts.insurance_options.some(
        (product: any) => product.canopy === true
      )
    );
  };

  const handleBonzahProductSelection = (
    productType: string,
    value: any,
    canopy: boolean
  ) => {
    const hasCanopy = hasCanopyOption();

    if (JSON.stringify(selectedBonzahType) === JSON.stringify(value)) {
      if (!hasCanopy) {
        setSelectedBonzahType([]);
        setSelectedBonzahProducts(new Set());
        fetchBonzahProducts();
      }
    } else {
      setSelectedBonzahType(value);
      setSelectedBonzahProducts(new Set([value]));
      fetchBonzahProducts(productType);
    }
  };

  const toggleDropOffLocation = () => {
    setIsDropOffVisible((prevState) => !prevState);
  };

  const handleDropOffLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(false);
    setSameDropoffLocation(false);
  };
  const handlePickupLocationClick = () => {
    toggleDropOffLocation();
    setDropoffLocationType(true);
    setSameDropoffLocation(true);
    setDropoffLocation(null);
  };

  useEffect(() => {
    const handleBeforeUnload = (e: BeforeUnloadEvent) => {
      e.preventDefault();
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  const handleOpenModalImageGallery = () => {
    if (selectedCar?.fleet_photos?.length === 0) {
      toast("No Images available for this fleet", {
        style: {
          background: "#fff3cd",
          color: "#856404",
        },
      });
    } else {
      setShowImgGallery(true);
    }
  };

  const vehicleDescriptionSection = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl font-semibold">Vehicle Description</h2>
        {selectedCar?.description && (
          <div className="break-words whitespace-pre-line">
            <p>
              {isReadMore
                ? selectedCar?.description?.slice(0, 230)
                : selectedCar?.description}
              {(selectedCar?.description?.length ?? 0) > 230 && (
                <span
                  className="text-primary-100 cursor-pointer"
                  onClick={toggleReadMore}
                >
                  {isReadMore ? " ...read more" : " ...show less"}
                </span>
              )}
            </p>
          </div>
        )}
        {selectedCar?.features && selectedCar.features.length > 0 && (
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-y-6 gap-x-10 text-sm">
            {selectedCar?.features?.map((item, index) => (
              <div key={index} className="flex items-center space-x-4 ">
                <span>{item.name}</span>
              </div>
            ))}
          </div>
        )}
      </div>
    );
  };

  const renderUserSection = () => {
    return (
      <div className="border-secondary-100 flex flex-col sm:rounded-md border-b sm:border-t sm:border-l sm:border-r sm:space-y-8 pb-10 px-0 sm:p-4 xl:p-8 !space-y-6">
        <h2 className="text-xl text-text-color  font-bold">Renter Details</h2>
        <div className="grid grid-cols-2 gap-6">
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm">First Name</span>
              <Input
                placeholder=""
                value={firstName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setFirstName(e.target.value);
                  if (e.target.value) clearError("firstName"); // Clear error if input is valid
                }}
              />
            </div>
            {errors.firstName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.firstName}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm">Last Name</span>
              <Input
                placeholder=""
                value={lastName}
                className="border-none !p-0 focus:outline-none focus:ring-0"
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setLastName(e.target.value);
                  if (e.target.value) clearError("lastName");
                }}
              />
            </div>
            {errors.lastName && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.lastName}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm">Email</span>
              <Input
                placeholder=""
                type="email"
                className="border-none !p-0 focus:outline-none focus:ring-0"
                value={email}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                  setEmail(e.target.value);
                  if (
                    /^[\w-]+(\.[\w-]+)*@([\w-]+\.)+[a-zA-Z]{2,7}$/.test(
                      e.target.value
                    )
                  ) {
                    clearError("email");
                  }
                }}
              />
            </div>
            {errors.email && (
              <span className="text-red-500 text-xs font-semibold">
                {errors.email}
              </span>
            )}
          </div>
          <div>
            <div className="border border-secondary-100 p-2 rounded-md">
              <span className="my-2 text-sm">Phone</span>
              <PhoneInput
                country={"us"}
                value={phone}
                onChange={(phone) => {
                  setPhone(phone);
                  if (phone.length >= 10) clearError("phone");
                }}
                inputProps={{
                  name: "phone",
                  required: true,
                  autoFocus: false,
                }}
                inputStyle={{
                  border: "none",
                  width: "100%",
                  minHeight: "44px",
                  boxShadow: "none",
                  background: "transparent",
                }}
                buttonStyle={{
                  background: "transparent",
                  border: "none",
                }}
              />
            </div>
            {errors.phone && (
              <span className="text-red-500 text-xs font-semibold ">
                {errors.phone}
              </span>
            )}
          </div>
        </div>
      </div>
    );
  };

  const handleExtraChange = (extraId: any, checked: any) => {
    setSelectedExtras((prevSelectedExtras) => {
      const updatedExtras = new Set(prevSelectedExtras);
      if (checked) {
        updatedExtras.add(extraId);
      } else {
        updatedExtras.delete(extraId);
      }
      return updatedExtras;
    });
  };

  const renderExtrasSection = () => {
    return (
      <div className="listingSection__wrap !mb-10">
        <h2 className="text-2xl font-bold text-text-color ">Extras</h2>
        {!bonzahProductsLoading &&
          !isMoreThan30Days &&
          bonzahProducts?.addons?.map((addon: any, index: any) => (
            <div
              key={index}
              className="flex flex-col justify-between items-start border border-secondary-100 rounded-md p-4 max-w-full"
            >
              <div className="flex items-start">
                <Checkbox
                  checked={selectedBonzahAddOns.has(addon.value[0])}
                  onChange={() => toggleAddonSelection(addon.value[0])}
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20 ring-inset  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${
                      selectedBonzahAddOns.has(addon.value[0])
                        ? "visible"
                        : "invisible"
                    }`}
                  />
                </Checkbox>

                <div>
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-text-color ">
                      {addon.title}
                    </h2>
                    <button
                      className="ml-2 text-text-color"
                      onClick={() => window.open(addon.pdf, "_blank")}
                    >
                      <svg
                        width="25"
                        height="24"
                        viewBox="0 0 25 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M12.7998 22.75C6.8698 22.75 2.0498 17.93 2.0498 12C2.0498 6.07 6.8698 1.25 12.7998 1.25C18.7298 1.25 23.5498 6.07 23.5498 12C23.5498 17.93 18.7298 22.75 12.7998 22.75ZM12.7998 2.75C7.6998 2.75 3.5498 6.9 3.5498 12C3.5498 17.1 7.6998 21.25 12.7998 21.25C17.8998 21.25 22.0498 17.1 22.0498 12C22.0498 6.9 17.8998 2.75 12.7998 2.75Z"
                          fill="#9AA3AD"
                        />
                        <path
                          d="M12.7998 13.75C12.3898 13.75 12.0498 13.41 12.0498 13V8C12.0498 7.59 12.3898 7.25 12.7998 7.25C13.2098 7.25 13.5498 7.59 13.5498 8V13C13.5498 13.41 13.2098 13.75 12.7998 13.75Z"
                          fill="#9AA3AD"
                        />
                        <path
                          d="M12.7998 16.9999C12.6698 16.9999 12.5398 16.9699 12.4198 16.9199C12.2998 16.8699 12.1898 16.7999 12.0898 16.7099C11.9998 16.6099 11.9298 16.5099 11.8798 16.3799C11.8298 16.2599 11.7998 16.1299 11.7998 15.9999C11.7998 15.8699 11.8298 15.7399 11.8798 15.6199C11.9298 15.4999 11.9998 15.3899 12.0898 15.2899C12.1898 15.1999 12.2998 15.1299 12.4198 15.0799C12.6598 14.9799 12.9398 14.9799 13.1798 15.0799C13.2998 15.1299 13.4098 15.1999 13.5098 15.2899C13.5998 15.3899 13.6698 15.4999 13.7198 15.6199C13.7698 15.7399 13.7998 15.8699 13.7998 15.9999C13.7998 16.1299 13.7698 16.2599 13.7198 16.3799C13.6698 16.5099 13.5998 16.6099 13.5098 16.7099C13.4098 16.7999 13.2998 16.8699 13.1798 16.9199C13.0598 16.9699 12.9298 16.9999 12.7998 16.9999Z"
                          fill="#9AA3AD"
                        />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>
              <div className="mt-4 md:mt-0 w-full">
                <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center">
                  ${addon.price.toFixed(2)}
                  <span className="text-text-color lg:text-lg">/day</span>
                </p>
              </div>
            </div>
          ))}
        {selectedCar?.extras.map((extra) => (
          <div
            key={extra.id}
            className="w-full rounded-md border border-secondary-100 flex justify-between items-center p-5"
          >
            <div className="flex justify-start">
              <Checkbox
                checked={selectedExtras?.has(extra.id)}
                onChange={(checked) => handleExtraChange(extra.id, checked)}
                className="group size-7 rounded-md  p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
              >
                <CheckIcon
                  className={`size-5 stroke-primary-200 ${
                    selectedExtras.has(extra.id) ? "visible" : "invisible"
                  }`}
                />
              </Checkbox>
              <div>
                <div className="text-text-color lg:text-lg sm:text-l font-bold flex space-x-2">
                  <span>{extra.name}</span>
                  {extra.is_required === true && (
                    <Badge color="blue" name="Recommended" />
                  )}
                </div>
                <div className="text-text-color lg:text-lg sm:text-md font-medium ">
                  {renderDescriptionWithLink(extra.description)}
                </div>
              </div>
            </div>

            <div className="mt-4 md:mt-0">
              <p className="lg:text-2xl text-lg font-bold text-text-color flex justify-end items-center">
                ${extra.amount}
                <span className="text-text-color lg:text-lg">
                  {" "}
                  /{extra.nature === "per_day" ? "day" : "trip"}
                </span>
              </p>
            </div>
          </div>
        ))}
      </div>
    );
  };

  const renderDescriptionWithLink = (description: string) => {
    // Regular expression to detect URLs
    const urlRegex = /(https?:\/\/[^\s]+)/g;

    // Split the description into parts: text and URLs
    const parts = description.split(urlRegex);

    return parts.map((part, index) => {
      // If the part matches the URL pattern, render it as a clickable link
      if (urlRegex.test(part)) {
        return (
          <a
            key={index}
            href={part}
            target="_blank"
            rel="noopener noreferrer"
            className="text-blue-500 hover:underline"
          >
            {part}
          </a>
        );
      }
      // Otherwise, render the text normally
      return <span key={index}>{part}</span>;
    });
  };

  const renderBonzahSection = () => {
    return (
      <div className="listingSection__wrap">
        <h2 className="text-2xl text-text-color font-bold">Trip Insurance</h2>
        {bonzahProducts?.insurance_options
          ?.filter(
            (product: any) =>
              !(isMoreThan30Days && product.insurance_by_bonzah === true)
          )
          .map((product: any, index: any) => (
            <div
              key={product.title}
              className="flex flex-col justify-between items-start  border border-secondary-100 rounded-md p-4 max-w-full overflow-hidden"
              style={{ wordBreak: "break-word" }}
            >
              <div className="flex items-start w-full">
                <Checkbox
                  checked={
                    JSON.stringify(selectedBonzahType) ===
                    JSON.stringify(product?.value)
                  }
                  onChange={() =>
                    handleBonzahProductSelection(
                      product.title.toLowerCase(),
                      product?.value,
                      product.canopy
                    )
                  }
                  className="group size-7 rounded-md p-1 ring-1 ring-primary-200 ring-inset data-[checked]:bg-primary-200 data-[checked]:bg-opacity-20  mr-4"
                >
                  <CheckIcon
                    className={`size-5 stroke-primary-200 ${
                      JSON.stringify(selectedBonzahType) ===
                      JSON.stringify(product?.value)
                        ? "visible"
                        : "invisible"
                    }`}
                  />
                </Checkbox>

                <div className="flex-1 min-w-0">
                  <div className="flex items-center mb-2">
                    <h2 className="text-lg md:text-xl font-bold text-text-color">
                      {product.title}
                    </h2>
                    {product?.pdf !== "" && (
                      <button
                        className="ml-2 text-text-color"
                        onClick={() => window.open(product.pdf, "_blank")}
                        type="button"
                        tabIndex={-1}
                      >
                        <svg
                          width="25"
                          height="24"
                          viewBox="0 0 25 24"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M12.7998 22.75C6.8698 22.75 2.0498 17.93 2.0498 12C2.0498 6.07 6.8698 1.25 12.7998 1.25C18.7298 1.25 23.5498 6.07 23.5498 12C23.5498 17.93 18.7298 22.75 12.7998 22.75ZM12.7998 2.75C7.6998 2.75 3.5498 6.9 3.5498 12C3.5498 17.1 7.6998 21.25 12.7998 21.25C17.8998 21.25 22.0498 17.1 22.0498 12C22.0498 6.9 17.8998 2.75 12.7998 2.75Z"
                            fill="#9AA3AD"
                          />
                          <path
                            d="M12.7998 13.75C12.3898 13.75 12.0498 13.41 12.0498 13V8C12.0498 7.59 12.3898 7.25 12.7998 7.25C13.2098 7.25 13.5498 7.59 13.5498 8V13C13.5498 13.41 13.2098 13.75 12.7998 13.75Z"
                            fill="#9AA3AD"
                          />
                          <path
                            d="M12.7998 16.9999C12.6698 16.9999 12.5398 16.9699 12.4198 16.9199C12.2998 16.8699 12.1898 16.7999 12.0898 16.7099C11.9998 16.6099 11.9298 16.5099 11.8798 16.3799C11.8298 16.2599 11.7998 16.1299 11.7998 15.9999C11.7998 15.8699 11.8298 15.7399 11.8798 15.6199C11.9298 15.4999 11.9998 15.3899 12.0898 15.2899C12.1898 15.1999 12.2998 15.1299 12.4198 15.0799C12.6598 14.9799 12.9398 14.9799 13.1798 15.0799C13.2998 15.1299 13.4098 15.1999 13.5098 15.2899C13.5998 15.3899 13.6698 15.4999 13.7198 15.6199C13.7698 15.7399 13.7998 15.8699 13.7998 15.9999C13.7998 16.1299 13.7698 16.2599 13.7198 16.3799C13.6698 16.5099 13.5998 16.6099 13.5098 16.7099C13.4098 16.7999 13.2998 16.8699 13.1798 16.9199C13.0598 16.9699 12.9298 16.9999 12.7998 16.9999Z"
                            fill="#9AA3AD"
                          />
                        </svg>
                      </button>
                    )}
                  </div>

                  {product?.options &&
                    Object.entries(product.options).map(([key, values]) => (
                      <div key={key} className="mt-2">
                        {!product.canopy && product.insurance_by_bonzah && (
                          <h3 className="font-semibold text-text-color uppercase truncate">
                            {key}
                          </h3>
                        )}

                        <p className="lg:text-lg text-md text-text-color break-words">
                          {(Array.isArray(values) ? values : [values]).map(
                            (detail, index) => {
                              // If detail is HTML from Quill editor, render as HTML but make links clickable
                              if (
                                typeof detail === "string" &&
                                detail.trim().startsWith("<")
                              ) {
                                // Replace URLs in HTML with anchor tags if not already wrapped
                                const urlRegex = /(https?:\/\/[^\s<>"']+)/g;
                                let html = detail.replace(urlRegex, (url) => {
                                  // If already inside an anchor tag, skip
                                  if (detail.includes(`<a href="${url}`))
                                    return url;
                                  return `<a href="${url}" target="_blank" rel="noopener noreferrer" class="text-blue-500 hover:underline">${url}</a>`;
                                });
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                    dangerouslySetInnerHTML={{ __html: html }}
                                  />
                                );
                              }
                              // If detail contains a URL, make it clickable
                              const urlRegex = /(https?:\/\/[^\s]+)/g;
                              if (
                                typeof detail === "string" &&
                                urlRegex.test(detail)
                              ) {
                                const parts = detail.split(urlRegex);
                                return (
                                  <span
                                    key={index}
                                    className={
                                      product.canopy
                                        ? "text-red-500 font-semibold"
                                        : ""
                                    }
                                    style={{ wordBreak: "break-word" }}
                                  >
                                    {parts.map((part, i) =>
                                      urlRegex.test(part) ? (
                                        <a
                                          key={i}
                                          href={part}
                                          target="_blank"
                                          rel="noopener noreferrer"
                                          className="text-blue-500 hover:underline"
                                          style={{ wordBreak: "break-word" }}
                                        >
                                          {part}
                                        </a>
                                      ) : (
                                        <React.Fragment key={i}>
                                          {part}
                                        </React.Fragment>
                                      )
                                    )}
                                    <br />
                                  </span>
                                );
                              }
                              // Otherwise, render as plain text
                              return (
                                <span
                                  key={index}
                                  className={
                                    product.canopy
                                      ? "text-red-500 font-semibold"
                                      : ""
                                  }
                                  style={{ wordBreak: "break-word" }}
                                >
                                  {detail}
                                  <br />
                                </span>
                              );
                            }
                          )}
                        </p>
                      </div>
                    ))}
                </div>
              </div>

              <div className="mt-4 md:mt-0 w-full flex justify-end items-center">
                <p className="lg:text-2xl text-lg font-bold text-text-color">
                  ${product.price.toFixed(2)}
                  <span className="text-text-color lg:text-lg">
                    /
                    {product.nature === "per_trip"
                      ? "trip"
                      : product.nature === "per_day"
                      ? "day"
                      : "24 hours"}
                  </span>
                </p>
              </div>
            </div>
          ))}
      </div>
    );
  };

  const renderSidebarPrice = () => {
    return (
      <div className="listingSectionSidebar__wrap shadow-xl mt-4 lg:mt-0 p-6 lg:p-12 lg:max-w-xl  ">
        <h2 className=" text-2xl sm:text-3xl lg:text-3xl font-bold text-text-color ">
          Booking Details
        </h2>
        <div className="mt-8 flex">
          <div className="flex-shrink-0 flex flex-col items-center py-2">
            <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
            <span className="block flex-grow border-l border-secondary-100 border-dashed my-1"></span>
            <span className="block w-6 h-6 rounded-full border border-secondary-100"></span>
          </div>
          <div className="ml-4 space-y-14 text-sm">
            <div className="flex flex-col space-y-2">
              <span className=" text-text-color ">Pick up</span>
              <span className=" font-semibold">
                {" "}
                {searchedPickupLoction
                  ? searchedPickupLoction
                  : pickupLocation?.name}
              </span>
              <span className=" font-semibold !mt-0">
                {moment(startDate).format("ddd, D MMM YYYY")}{" "}
                {moment(startDate).format("hh:mm A")}
              </span>
            </div>
            <div className="flex flex-col space-y-2">
              <span className=" text-text-color ">Drop Off</span>
              <span className=" font-semibold">
                {dropoffLocationType === false &&
                searchedDropoffLocation.length > 0
                  ? searchedDropoffLocation
                  : dropOffLocation?.name
                  ? dropOffLocation?.name
                  : dropoffLocationType === true &&
                    searchedPickupLoction.length > 0
                  ? searchedPickupLoction
                  : pickupLocation?.name}
              </span>
              <span className=" font-semibold !mt-0">
                {moment(endDate).format("ddd, D MMM YYYY")}{" "}
                {moment(endDate).format("hh:mm A")}
              </span>
            </div>
          </div>
        </div>

        <div className="w-full max-w-lg  mx-auto ">
          <h2 className="text-xl font-medium text-text-color">Rental Bill</h2>
          <p className="mt-2 text-sm text-text-color">
            Prices may change depending on the length of the rental and the
            price of your rental car.
          </p>

          {pickupLocation !== null && invoice?.car_total !== undefined && (
            <>
              <div className="mt-4">
                <div className="pb-4">
                  <span className="text-lg font-semibold text-text-color">
                    Trip Price
                  </span>
                </div>
              </div>

              <div className="flex justify-between truncate">
                <span>{selectedCar?.name}</span>
                <span className="flex flex-col items-end ">
                  <span className="text-xl font-medium text-text-color">
                    ${Number(invoice?.car_total).toFixed(2)}
                  </span>
                  <span className="text-sm text-text-color">
                    ${invoice?.avg_car_price_per_day + " x "}
                    {invoice?.trip_days + "-Days  "}
                  </span>
                </span>
              </div>

              {invoice?.breakdown?.locations?.length > 0 &&
                invoice?.location_total !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-text-color">
                        Location Total
                      </span>
                    </div>
                    {invoice?.breakdown?.locations?.map(
                      (location: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span>{location?.name}</span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-text-color">
                              ${Number(location?.total).toFixed(2)}
                            </span>
                            <span className="text-sm text-text-color">
                              {location?.rate}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.breakdown?.insurance?.length > 0 &&
                invoice?.insurance_total !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-text-color">
                        Insurance Total
                      </span>
                    </div>
                    {invoice?.breakdown?.insurance?.map(
                      (insurance: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span>{insurance?.name}</span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-text-color">
                              ${Number(insurance?.total).toFixed(2)}
                            </span>
                            <span className="text-sm text-text-color">
                              {insurance?.rate}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.breakdown?.extras?.length > 0 &&
                invoice?.extras_total !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-text-color">
                        Trip Extras
                      </span>
                    </div>
                    {invoice?.breakdown?.extras?.map(
                      (extra: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span>{extra?.name}</span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-text-color">
                              ${Number(extra?.total).toFixed(2)}
                            </span>
                            <span className="text-sm text-text-color">
                              ${extra?.rate}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.booking_fee !== "0.00" &&
                invoice?.booking_fee !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-text-color">
                        Booking Fee
                      </span>
                    </div>
                    {invoice?.breakdown?.booking_fee?.map(
                      (bookingFee: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span>
                            {" "}
                            {bookingFee?.description
                              ? bookingFee?.description
                              : bookingFee?.name}
                          </span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-text-color">
                              ${Number(bookingFee?.total).toFixed(2)}
                            </span>
                            <span>
                              {bookingFee?.rate.includes("%")
                                ? bookingFee?.rate
                                : `$${bookingFee?.rate}`}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.breakdown?.taxes?.length > 0 &&
                invoice?.tax !== undefined && (
                  <div className="mt-4">
                    <div className="pb-4">
                      <span className="text-lg font-semibold text-text-color">
                        Tax
                      </span>
                    </div>
                    {invoice?.breakdown?.taxes?.map(
                      (taxes: any, index: any) => (
                        <div key={index} className="flex justify-between ">
                          <span>
                            {" "}
                            {taxes?.description
                              ? taxes?.description
                              : taxes?.name}
                          </span>
                          <div className="flex flex-col items-end">
                            <span className="text-xl font-medium text-text-color">
                              ${Number(taxes?.total).toFixed(2)}
                            </span>
                            <span>
                              {taxes?.rate.includes("%")
                                ? taxes?.rate
                                : `$${taxes?.rate}`}
                            </span>
                          </div>
                        </div>
                      )
                    )}
                  </div>
                )}

              {invoice?.discount !== "0.00" &&
                invoice?.discount !== undefined && (
                  <div className="mt-4">
                    <div className="flex justify-between ">
                      <span className="text-lg font-normal text-text-color">
                        Discount
                      </span>
                      <span className="text-xl font-medium text-text-color">
                        - ${Number(invoice.discount).toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}

              <div className="mt-8 border-t border-secondary-100  pt-4">
                {invoice.total_price_without_security !== "0.00" &&
                  invoice.total_price_without_security !== undefined && (
                    <div className="flex justify-between ">
                      <div>
                        <span className="text-lg font-semibold text-text-color">
                          Total Rental Price
                        </span>
                        <p className="mt-1 text-sm text-text-color">
                          Overall price rental
                        </p>
                      </div>
                      <div>
                        <span className="text-xl font-medium text-text-color">
                          $
                          {Number(invoice.total_price_without_security).toFixed(
                            2
                          )}
                        </span>
                      </div>
                    </div>
                  )}
              </div>

              {invoice.security_deposit_total !== "0.00" &&
                invoice.security_deposit_total !== undefined && (
                  <div className="mt-4">
                    <div className="flex justify-between ">
                      <span className="text-lg font-semibold text-text-color">
                        Refundable Deposit
                      </span>
                      <span className="text-xl font-medium text-text-color">
                        ${Number(invoice.security_deposit_total).toFixed(2)}
                      </span>
                    </div>
                  </div>
                )}
            </>
          )}
        </div>

        <ButtonPrimary
          className="block rounded-3xl"
          disabled={loading}
          onClick={() => {
            handleBooking();
          }}
        >
          {loading ? (
            <div className="flex justify-center items-center col-span-full">
              <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-secondary-100"></div>
            </div>
          ) : (
            "Pay & Book"
          )}
        </ButtonPrimary>
        {selectedCar?.pay_later && (
          <ButtonPrimary
            className="block rounded-lg mt-4"
            disabled={loadingLater}
            onClick={() => {
              handleBookingLater();
            }}
          >
            {loadingLater ? (
              <div className="flex justify-center items-center col-span-full">
                <div className="spinner-border animate-spin inline-block w-6 h-6 border-4 rounded-full border-t-transparent border-gray-300"></div>
              </div>
            ) : (
              "Pay Later"
            )}
          </ButtonPrimary>
        )}
      </div>
    );
  };
  return (
    <DetailPagetLayout
      showImgGallery={showImgGallery}
      setShowImgGallery={setShowImgGallery}
    >
      <>
        <div className={` nc-ListingCarDetailPage `}>
          <header className="rounded-md sm:rounded-md">
            <div className="relative grid grid-cols-1 md:grid-cols-4  gap-1 sm:gap-2 min-h-96 ">
              <div
                className="col-span-2 row-span-2 relative rounded-md sm:rounded-md overflow-hidden cursor-pointer"
                onClick={handleOpenModalImageGallery}
              >
                <img
                  src={
                    (selectedCar?.fleet_photos?.length ?? 0) > 0
                      ? selectedCar?.fleet_photos[0].photo_url.includes("http")
                        ? selectedCar?.fleet_photos[0].photo_url
                        : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[0].photo_url}`
                      : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                  }
                  alt="0"
                  className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                  sizes="(max-width: 768px) 100vw, (max-width: 1200px) 50vw, 50vw"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>

              {/*  */}
              <div
                className="col-span-1 row-span-2 relative rounded-md sm:rounded-md overflow-hidden cursor-pointer"
                onClick={handleOpenModalImageGallery}
              >
                <img
                  className="absolute inset-0 object-cover rounded-md sm:rounded-md w-full h-full"
                  src={
                    (selectedCar?.fleet_photos?.length ?? 0) > 1
                      ? selectedCar?.fleet_photos[1].photo_url.includes("http")
                        ? selectedCar?.fleet_photos[1].photo_url
                        : `https://fleet-management-images-upload-be.s3.amazonaws.com/${selectedCar?.fleet_photos[1].photo_url}`
                      : "https://tenant.fleetwire.io/images/vehicle-placeholder.jpg"
                  }
                  alt="1"
                  sizes="400px"
                />
                <div className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity"></div>
              </div>

              {/*  */}
              {selectedCar?.fleet_photos
                .filter((_, i) => i >= 2 && i < 4)
                .map((item, index) => (
                  <div
                    key={index}
                    className={`relative rounded-md sm:rounded-md overflow-hidden ${
                      index >= 2 ? "block" : ""
                    }`}
                  >
                    <div className="aspect-w-4 aspect-h-3">
                      <img
                        className="absolute inset-0 object-cover w-full h-full rounded-md sm:rounded-md "
                        src={
                          item.photo_url.includes("http")
                            ? item.photo_url
                            : `https://fleet-management-images-upload-be.s3.amazonaws.com/${item.photo_url}`
                        }
                        alt="photos"
                        sizes="400px"
                      />
                    </div>
                    <div
                      className="absolute inset-0 bg-neutral-900 bg-opacity-20 opacity-0 hover:opacity-100 transition-opacity cursor-pointer"
                      onClick={handleOpenModalImageGallery}
                    />
                  </div>
                ))}

              {(selectedCar?.fleet_photos?.length ?? 0) > 0 && (
                <div
                  className="absolute flex md:items-center md:justify-center left-3 bottom-3 px-4 py-2 rounded-md bg-secondary-50 text-text-color cursor-pointer z-10"
                  onClick={handleOpenModalImageGallery}
                >
                  <Squares2X2Icon className="h-5 w-5" />
                  <span className="ml-2 text-text-color text-sm font-medium">
                    Show all photos
                  </span>
                </div>
              )}
            </div>
          </header>

          <main className=" relative z-10 mt-11 flex flex-col lg:flex-row ">
            <div className="w-full lg:w-3/5 xl:w-2/3 space-y-8 lg:pr-10 lg:space-y-10">
              {(selectedCar?.description ||
                (selectedCar?.features && selectedCar.features.length > 0)) &&
                vehicleDescriptionSection()}
              {renderUserSection()}
              {bonzahProducts?.insurance_options?.length > 0 &&
                renderBonzahSection()}
              {(bonzahProducts?.addons?.length > 0 ||
                (selectedCar?.extras ?? []).length > 0) &&
                renderExtrasSection()}
            </div>

            <div className="block flex-grow mt-0 lg:mt-0">
              <div className="block sticky top-28">{renderSidebarPrice()}</div>
            </div>
          </main>
        </div>
      </>
    </DetailPagetLayout>
  );
}
